import { container } from "tsyringe";

// shared
import StoreManagerImpl from "@/shared/libs/state-management";
import type { AcademyClassState } from "@/shared/types/features/academy-class";
import type { ClientStateManager } from "@/shared/types/adapter/client-interface";

// features
import useAcademyClassStore from "@/features/academy/model/store";

export const registerAcademyProviders = () => {
    container.register<ClientStateManager.AcademyClassManager>("AcademyClassManager", {
        useValue: new StoreManagerImpl<AcademyClassState>(useAcademyClassStore()),
    });
};
